import { type NotificationCategory, type UserNotificationSettings } from '@/models/user';

import { EMAIL_ONLY_NOTIFICATION_CATEGORIES } from './getChannelSelectionStateByCategory';

type Channel = 'email' | 'in_app';

/**
 * Update user notification settings when toggling a channel for a category (or all categories).
 * When category is 'all', applies the change to every category that supports the channel.
 */
export const setNotificationSettings = (
  channel: Channel,
  enabled: boolean,
  category: NotificationCategory | 'all',
  userNotificationSettings: UserNotificationSettings
): UserNotificationSettings => {
  const updateChannels = (currentChannels: ('in_app' | 'email')[]): ('in_app' | 'email')[] => {
    if (enabled) {
      return [...new Set([...currentChannels, channel])] as ('in_app' | 'email')[];
    }

    return currentChannels.filter((c) => c !== channel);
  };

  if (category === 'all') {
    const result = { ...userNotificationSettings };

    for (const key of Object.keys(result) as NotificationCategory[]) {
      if (channel === 'in_app' && EMAIL_ONLY_NOTIFICATION_CATEGORIES.includes(key)) {
        continue;
      }

      result[key] = updateChannels(result[key]);
    }

    return result;
  }

  return {
    ...userNotificationSettings,
    [category]: updateChannels(userNotificationSettings[category]),
  };
};
